/* Yatas Bedding NL — "Eerder bekeken".
 *
 * Two halves:
 *   1. On a product page, record a compact record of the product in
 *      localStorage (newest first, de-duplicated, capped).
 *   2. Anywhere the section is placed, render cards from that history.
 *
 * Everything needed to draw a card is captured at visit time, so rendering
 * needs no extra network requests.
 */
(function () {
  'use strict';

  const KEY = 'ybn:recently-viewed';
  const MAX = 24;

  function read() {
    try {
      const raw = window.localStorage.getItem(KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      // Private mode or a corrupt value - treat as no history.
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* storage full or unavailable - history is not important enough to surface */
    }
  }

  /* ------------------------------------------------------------- recording */
  function record() {
    const el = document.querySelector('[data-recent-record]');
    if (!el) return;

    let item;
    try {
      item = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    if (!item || !item.handle) return;

    const list = read().filter((x) => x.handle !== item.handle);
    list.unshift(item);
    write(list);
  }

  /* -------------------------------------------------------------- rendering */
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[c]);
  }

  function cardHtml(item) {
    const title = item.model
      ? `<strong>${escapeHtml(item.model)}</strong> ${escapeHtml(item.rest || '')}`
      : escapeHtml(item.title);

    const badges = (item.badges || [])
      .slice(0, 2)
      .map(
        (b) =>
          `<span class="ybn-card__tag ybn-card__tag--${escapeHtml(
            (b.color || 'grey').toLowerCase()
          )}">${escapeHtml(b.label)}</span>`
      )
      .join('');

    const dots = item.hardnessLevel
      ? `<span class="ybn-card__hardness"><span class="ybn-card__hardness-label">${escapeHtml(
          item.hardness || ''
        )}</span><span class="ybn-card__dots">${[1, 2, 3, 4]
          .map(
            (i) =>
              `<span class="ybn-card__dot${i <= item.hardnessLevel ? ' is-on' : ''}"></span>`
          )
          .join('')}</span></span>`
      : '';

    const usps = (item.usps || [])
      .slice(0, 2)
      .map((u) => `<li>${escapeHtml(u)}</li>`)
      .join('');

    return `
      <article class="ybn-card">
        <div class="ybn-card__media-wrap">
          <a class="ybn-card__media" href="${escapeHtml(item.url)}">
            ${item.image ? `<img class="ybn-card__img" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}
            ${badges ? `<span class="ybn-card__badges">${badges}</span>` : ''}
          </a>
        </div>
        <div class="ybn-card__body">
          <h3 class="ybn-card__title"><a href="${escapeHtml(item.url)}">${title}</a></h3>
          <div class="ybn-card__meta">
            <span class="ybn-card__size">${escapeHtml(item.size || '')}</span>
            ${dots}
          </div>
          ${usps ? `<ul class="ybn-card__usps">${usps}</ul>` : ''}
          <div class="ybn-card__foot">
            <span class="ybn-card__price"><span class="ybn-card__price-now">${escapeHtml(item.price)}</span></span>
            ${item.brand ? `<span class="ybn-card__brand">${escapeHtml(item.brand)}</span>` : ''}
          </div>
        </div>
      </article>`;
  }

  class YbnRecentlyViewed extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-recent-track]');
      if (!track) return;

      const exclude = this.dataset.exclude || '';
      const limit = parseInt(this.dataset.limit, 10) || 12;

      const items = read()
        .filter((x) => x.handle && x.handle !== exclude)
        .slice(0, limit);

      // Nothing to show: leave the section hidden rather than render an
      // empty heading.
      if (!items.length) return;

      track.innerHTML = items
        .map((i) => `<div class="ybn-carousel__slide" data-slide>${cardHtml(i)}</div>`)
        .join('');

      this.hidden = false;

      // The carousel measured itself while the track was empty.
      this.querySelectorAll('ybn-carousel').forEach((c) => {
        c.slides = Array.from(track.querySelectorAll('[data-slide]'));
        c.applyPerView?.();
        c.buildDots?.();
      });
    }
  }

  if (!customElements.get('ybn-recently-viewed')) {
    customElements.define('ybn-recently-viewed', YbnRecentlyViewed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', record);
  } else {
    record();
  }
})();
